import Toggle from 'react-toggle'
import './SubscriptionList.scoped.scss'
import restClient from 'Shared/hooks/restClient'

function Subscription({ value, kind, topic, updatedAt, label, organisationTargetId, updateEndpoint }) {
  const [checked, setChecked] = useState(value)
  const [saving, setSaving] = useState(false)
  const [lastChanged, setLastChanged] = useState(updatedAt)
  const [feedback, setFeedback] = useState('')

  const handleChange = (e) => {
    setSaving(true)
    setChecked(e.target.checked)
    restClient
      .put(updateEndpoint, { organisationTargetId, subscription: { kind, topic, subscribed: e.target.checked } })
      .then((r) => {
        setChecked(r.data.subscribed)
        setLastChanged(r.data.updatedAt)
        setSaving(false)
        setFeedback('Updated')
        setTimeout(() => setFeedback(''), 3000)
      })
      .catch((e) => {
        console.error(e)
        setSaving(false)
        setFeedback('Error')
      })
  }

  const formattedDate = lastChanged ? new Date(lastChanged).toLocaleDateString('default') : 'Never'

  return (
    <>
      <span>{label}</span>
      <div className="feedback-toggle">
        <span className="feedback">{feedback}</span>
        <Toggle name={`${kind}:${topic}`} checked={checked} disabled={saving} onChange={handleChange} />
      </div>
      <span className="ml-2 text-sm text-gray-600">Last changed: <span className="date">{formattedDate}</span></span>
    </>
  )
}

export default function SubscriptionList({ subscriptions, organisationTargetId, updateEndpoint, fontSizes = 'large' }) {
  const nonDefaultTopics = _.some(_.flatten(_.values(subscriptions)), (topic) => topic.topic !== 'default')

  return (
    <div>
      {_.map(subscriptions, (topics, kind) => {
        return (
          <div key={kind} className="subscription-kind">
            {nonDefaultTopics && (
              fontSizes === 'small' ?
                <p className='bold dark-grey'>{_.startCase(kind)}</p>
                :
                <h3>{_.startCase(kind)}</h3>
            )}
            <div className={`subscription-list ${nonDefaultTopics ? '' : 'margin-bottom half'}`}>
              {topics.map((topic) => (
                <Subscription key={topic.topic} {...{ ...topic, organisationTargetId, updateEndpoint }} />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
